import React, {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
// リダイレクト(認証期間切れの場合にリダイレクトするため)
import {useHistory} from "react-router-dom";
import moment from 'moment';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField/TextField";
import Typography from "@material-ui/core/Typography";
import Select from "react-select";
import makeAnimated from "react-select/animated";

import {
  apollo_useStyles,
  Option,
} from "../../atom/Apollo_styles";
import {
  apollo_industory_master_relation_path,
  apollo_industory_master_path,
	apollo_industorycategory_master_path,
} from "../../atom/Apollo_links";
import {
  IndustoryMasterRelation,
} from "../../pages/MASTER/MasterModel";
import {
  RequestIndustory,
	Industorycategory,
} from "./Apollo_MasterModel";

// 共通部品
import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
import {ApolloMessage} from "../../atom/Apollo_Mesasge";
import {ApolloContext} from "../../atom/Apollo_Context";
import {LogData, ApolloEventRecord} from "../../atom/Apollo_EventRecord";
import {checkCommonInvalidTextChar} from "../../common/Apollo_CommonUtil";
// メッセージ定義
import {
  GetMessage,
  UI_MASTER_INDUSTORY_EDIT,
} from "../../atom/Apollo_MesasgeDefinition";
// ドロワー(認証期間切れの場合にドロワーを閉じるため)
import {ApolloRightDrawerContext, RightDrawer} from "../../molecule/Apollo_RightDrawer";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

// セレクトボックスで使用
const animatedComponents = makeAnimated();

export default function ApolloMasterIndustoryEdit(props: {
	industoryId: number,
	industorycategoryId: number,
	read: boolean,
	setRead: any,
	close: any,
}) {
	const {read, setRead} = props;
  	const {register, handleSubmit, errors} = useForm();
	const classes = apollo_useStyles();
	const {data, setmsg} = React.useContext(ApolloMessage);
	const [master, setMaster] = useState<IndustoryMasterRelation>();
	const [industorycategory, setIndustorycategory] = React.useState<Industorycategory[]>();
	const [optionCategories, setOptionCategories] = React.useState<Option[]>([]);
	const [categoryIdLocal, setCategoryIdLocal] = React.useState<number>(props.industorycategoryId);
	const {state: apolloContex} = React.useContext(ApolloContext);
	
	// 再読み込み
	const [reRead, setReRead] = useState(true);
	// ドロワー(認証期間切れの場合にドロワーを閉じるため)
	const {drawerState, setDrawerState} = React.useContext(ApolloRightDrawerContext);
	// リダイレクト(認証期間切れの場合にリダイレクトするため)
	const history = useHistory();

	useEffect(() => {
		setmsg({
			type: "loading",
			payload: {
				...data,
				loading: true,
			}
		});
		// 業種カテゴリ取得
    const urlIndustorycategory = apollo_industorycategory_master_path;
    ApolloAxios.get(urlIndustorycategory).then(response => {
		if (response.data.resultCode === 0) {
        initList(response.data.result);
				setmsg({
					type: "all",
					payload: {
						...data,
						loading: false,
					}
				});
      } else {
        console.log(response.data.message);
				setmsg({
					type: "all",
					payload: {
						...data,
						open: true,
						loading: false,
						type: "error",
						message: GetMessage("0",UI_MASTER_INDUSTORY_EDIT,"E","3"),
					},
				});
			}
    }).catch(err => {
			// 認証期間切れ判定とエラーメッセージ表示
			if (!ApolloExpired(err, GetMessage("0",UI_MASTER_INDUSTORY_EDIT,"E","3"), data, setmsg, history, setDrawerState, drawerState)) {
				// 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
			}
    });
		// 新規登録の場合は取得しない
		if (props.industoryId === 0) return;
		// 業種マスタ取得
		const path = apollo_industory_master_relation_path + "/" + props.industoryId;
		ApolloAxios.get(path).then(response => {
			if (response.data.resultCode === 0) {
				setMaster(response.data.result);
				setmsg({
					type: "all",
					payload: {
						...data,
						loading: false,
					}
				});
			} else {
				console.log(response.data.message)
				setmsg({
					type: "all",
					payload: {
						...data,
						open: true,
						type: "error",
						message: GetMessage("0",UI_MASTER_INDUSTORY_EDIT,"E","0"),
						loading: false,
					}
				});
			}
		}).catch(err => {
			// 認証期間切れ判定とエラーメッセージ表示
			if (!ApolloExpired(err, GetMessage("0",UI_MASTER_INDUSTORY_EDIT,"E","0"), data, setmsg, history, setDrawerState, drawerState)) {
				// 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
			}
		});
	}, []);

	// セレクトボックス初期設定
	const initList = (industorycategory:Industorycategory[]) => {
		setIndustorycategory(industorycategory);
		// 業種カテゴリリストを作成する
		createCategoryOption(industorycategory);
	}
	
	// 業種カテゴリ選択リスト作成
	function createCategoryOption(industorycategory:Industorycategory[]) {
		var options_category: Option[];
		options_category = industorycategory? industorycategory.map((option) => {
			return {value:option.industorycategoryId, label:option.industorycategoryName}
		}) : [];
		setOptionCategories(options_category);
	}
	
	// 変更ボタンハンドラ
  const onSubmit = handleSubmit(async (body: any) => {
		// 業種未選択チェック
		if (categoryIdLocal === 0) {
			setmsg({
				type: "setMessage",
				payload: {
					...data,
					open: true,
					type: "error",
					message: GetMessage("0",UI_MASTER_INDUSTORY_EDIT,"V","0"),
				}
			});
			return;
		}
		
		let beforeIndustoryName = master?.industoryName ?? "";
		let afterIndustoryName = body.industoryName;

		var executeLogData: LogData = {
			eventDate:  moment().format("YYYY-MM-DD HH:mm:ss"),
			logType: "execute", // ログ種別 実行：execute, 結果：result
			result: "", // 実行結果 成功 / 失敗 ※実行時は空文字
			userID: apolloContex.userprofile.userId,
			userName:  apolloContex.userprofile.userName,
			accessToken:  apolloContex.accesstoken,
			displayName: "業種マスタ画面",
			category: "マスタ", // 操作対象 キャンペーン / セグメント etc...
			actionType: "作成",
			accountGroupID: apolloContex.current.accountGroupId,
			accountGroupName: apolloContex.current.accountGroupName,
			accountID: apolloContex.current.accountId,
			accountName: apolloContex.current.accountName,
			campaignID: "", // キャンペーンID
			campaignName: "", // キャンペーン名
			adGroupID: "", // 広告グループID
			adGroupName: "", // 広告グループ名
			targetID: "", // 操作を行うデータのID 実行時は空文字
			targetName: "", // 操作を行うデータの名称 実行時は空文字
			menu: "",
			itemList: [
				{key:"industoryName", beforeValue:"", afterValue:afterIndustoryName},
			]
		};

		// 業種マスタ登録・更新リクエスト
		var requestMaster:RequestIndustory = {
			industoryName: body.industoryName,
			industorycategoryId: categoryIdLocal,
		}

		if (props.industoryId === 0) {
			// URL
			const url = apollo_industory_master_path;
			ApolloEventRecord(executeLogData);

			// 業種マスタ登録
			ApolloAxios.post(url, requestMaster).then(response => {
				if (response.data.resultCode === 0) {
					executeLogData.eventDate = moment().format("YYYY-MM-DD HH:mm:ss");
					executeLogData.logType = "result";
					executeLogData.result = "成功";

					ApolloEventRecord(executeLogData);
					setmsg({
						type: "setMessage",
						payload: {
							...data,
							open: true,
							type: "success",
							message: GetMessage("0",UI_MASTER_INDUSTORY_EDIT,"I","0")
						}
					});
					// 呼び出し元・再読み込み
					setRead(!read);
					setReRead(!reRead);
					handleClose();
				} else {
					executeLogData.eventDate = moment().format("YYYY-MM-DD HH:mm:ss:ss");
					executeLogData.logType = "result";
					executeLogData.result = "失敗";
					
					ApolloEventRecord(executeLogData);
					console.log(response.data.message);
					setmsg({
						type: "setMessage",
						payload: {
							...data,
							open: true,
							type: "error",
							message: GetMessage("0",UI_MASTER_INDUSTORY_EDIT,"E","1"),
						}
					});
				}
			}).catch(err => {
				executeLogData.eventDate = moment().format("YYYY-MM-DD HH:mm:ss");
				executeLogData.logType = "result";
				executeLogData.result = "失敗";
				
				ApolloEventRecord(executeLogData);

				// 認証期間切れ判定とエラーメッセージ表示
				if (!ApolloExpired(err, GetMessage("0",UI_MASTER_INDUSTORY_EDIT,"E","1"), data, setmsg, history, setDrawerState, drawerState)) {
					// 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
				}
			})
		} else {
			// URL
			const url = apollo_industory_master_path + "/" + props.industoryId;
			executeLogData.actionType = "更新";
			executeLogData.targetID = props.industoryId.toString();
			executeLogData.logType = "execute";
			executeLogData.result = "";
			executeLogData.itemList = [
				{key:"industoryName", beforeValue:beforeIndustoryName, afterValue:afterIndustoryName},
			];

		 	ApolloEventRecord(executeLogData);

			// 業種マスタ更新
			ApolloAxios.put(url, requestMaster).then(response => {
				if (response.data.resultCode === 0) {
					executeLogData.eventDate = moment().format("YYYY-MM-DD HH:mm:ss");
					executeLogData.logType = "result";
					executeLogData.result = "成功";
					
					ApolloEventRecord(executeLogData);
					setmsg({
						type: "setMessage",
						payload: {
							...data,
							open: true,
							type: "success",
							message: GetMessage("0",UI_MASTER_INDUSTORY_EDIT,"I","1")
						}
					});
					// 呼び出し元・再読み込み
					setRead(!read);
					setReRead(!reRead);
					handleClose();
				} else {
					executeLogData.eventDate = moment().format("YYYY-MM-DD HH:mm:ss");
					executeLogData.logType = "result";
					executeLogData.result = "失敗";
					
					ApolloEventRecord(executeLogData);
					console.log(response.data.message);
					setmsg({
						type: "setMessage",
						payload: {
							...data,
							open: true,
							type: "error",
							message: GetMessage("0",UI_MASTER_INDUSTORY_EDIT,"E","2"),
						}
					});
				}
			}).catch(err => {
				executeLogData.eventDate = moment().format("YYYY-MM-DD HH:mm:ss");
				executeLogData.logType = "result";
				executeLogData.result = "失敗";
				
				ApolloEventRecord(executeLogData);

				// 認証期間切れ判定とエラーメッセージ表示
				if (!ApolloExpired(err, GetMessage("0",UI_MASTER_INDUSTORY_EDIT,"E","2"), data, setmsg, history, setDrawerState, drawerState)) {
					// 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
				}
			})
		}
	});

	// キャンセルボタンハンドラ
  const handleClose = () => {
		props.close();
	}

	// 業種カテゴリ変更ハンドラ
  const onChangeOption = (event: any) => {
    setCategoryIdLocal(event.value);
  }

	//// 画面表示
	return (
		<Card square variant="outlined" style={{height: 500}}>
      <form noValidate onSubmit={onSubmit}>
				<CardContent style={{padding:10}}>
					<Card className={classes.root} square variant="outlined" style={{height: 420}}>
						<CardContent style={{padding:10}}>
							{/* 業種ID */}
							<Grid item xs={12}>
                <TextField
                  id="industoryId"
                  name="industoryId"
                  label="業種ID"
                  fullWidth
                  key={master ? "Loaded" : "Loading"}
                  defaultValue={master && master.industoryId}
                  autoComplete="業種ID"
									disabled={true}
                />
              </Grid>
							{/* 業種名称 */}
							<Grid item xs={12}>
                <TextField
                  id="industoryName"
                  name="industoryName"
				  label="業種名"
				  inputRef={register({
					  required: "必須入力項目です。",
					  maxLength: {
						  value: 255,
						  message: "255文字以内で入力して下さい。"
					  },
					  validate: (e: string) => {
						  return checkCommonInvalidTextChar(e);
					  }
                  })}
                  required
                  fullWidth
                  key={master ? "Loaded" : "Loading"}
                  defaultValue={master && master.industoryName}
                  helperText={errors.industoryName && errors.industoryName.message}
                  error={errors.industoryName ? true : false}
                  autoComplete="業種名"
                />
              </Grid>
							<Grid item xs={12}>
								<Typography variant="subtitle1" gutterBottom component="div">
									業種カテゴリ
								</Typography>
								<Select
									id="industorycategory"
									name="industorycategory"
									closeMenuOnSelect={true}
									components={animatedComponents}
									key={industorycategory ? "Loaded" : "Loading"}
									value={categoryIdLocal ? optionCategories.find((v) => v.value === categoryIdLocal) : {value:0, label:""}}
									options={optionCategories}
									onChange={(e) => onChangeOption(e)}
								/>
							</Grid>
						</CardContent>
					</Card>
				</CardContent>
				<Button className={classes.buttonTop} variant="contained" color="primary" onClick={onSubmit}>
					{props.industoryId === 0 ?
						"新規に登録"
					:
						"変更を保存"
					}
					</Button>
					<Button className={classes.buttonTop} variant="contained" color="primary" onClick={()=>handleClose()}>
					キャンセル
					</Button>
				</form>
		</Card>
	);
}
